import React, { useState, useEffect, useRef } from 'react';
import './FollowTheBeatModule7.css';
import { API } from 'aws-amplify';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import PopUp from '../Popup/logoutPopup';
import { getVideo } from '../s3Func/s3Download';
import LottieAnimation from '../components/Lottie/LottieAnimation';
import loading from './../loading-gif-png-5.gif';
import left from './left_hand.svg'
import right from './right_hand.svg'

const FollowTheBeatModule7 = (props) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const lottieRef = useRef()
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const dog = generateImageUrl('images/Module2Images/Dog+Still.gif');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const coin = generateImageUrl('images/Images/Coin_Empty.png');

  const [playInstructions, setPlayInstructions] = useState(false);
  const [dogState, setDogState] = useState(dog);
  const [playSong, setPlaySong] = useState(false);
  const [song, setSong] = useState(props.song);
  const [playAwesomeJob, setPlayAwesomeJob] = useState(false);

  const [coinAnimationState, setCoinAnimationState] = useState('');
  const [showCoin, setShowCoin] = useState(false);

  const [CountingGif, setCountingGif] = useState(props.count);
  const [counting, setCounting] = useState(false);

  const [awesomeJobAudio, setAwesomeJobAudio] = useState('');
  const [clappingAudio, setClappingAudio] = useState('');
  const [poppingAudio, setPoppingAudio] = useState('');
  const [showAnimal, setShowAnimal] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [score, setScore] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [tutorial, setTutorial] = useState(props.tutorial1);

  const [Exit, setExit] = useState(
    generateImageUrl('images/Images/close.png')
  );

  // Voice audio refs/state
  const voiceAudioRef = useRef(null);
  const expectedVoiceSrcRef = useRef('');
  const voiceEndActionRef = useRef(null);
  const [voiceSrc, setVoiceSrc] = useState('');
  const [voiceShouldPlay, setVoiceShouldPlay] = useState(false);

  // Music audio refs/state
  const musicAudioRef = useRef(null);
  const expectedMusicSrcRef = useRef('');
  const musicEndActionRef = useRef(null);
  const musicOnPlayActionRef = useRef(null);
  const [musicSrc, setMusicSrc] = useState('');
  const [musicShouldPlay, setMusicShouldPlay] = useState(false);

  // SFX audio refs/state
  const sfxAudioRef = useRef(null);
  const expectedSfxSrcRef = useRef('');
  const [sfxSrc, setSfxSrc] = useState('');
  const [sfxShouldPlay, setSfxShouldPlay] = useState(false);

  useEffect(() => {
    getGifs();
  }, []);

  // Starts the application
  useEffect(() => {
    controllerStart();
  }, []);

  

  function getGifs() {
    setAwesomeJobAudio(getVideo('appfiles/answer/answer_amazing_job.mp3', login));
    setClappingAudio(getVideo('appfiles/ftb/single_clap.mp3', login));
    setPoppingAudio(getVideo('appfiles/ftb/bubble_pop.mp3', login));
  }

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // Helper to programmatically play voice audio
  const playVoiceAudio = async (src, onEndedAction = null, restartIfSame = true) => {
    if (src && typeof src.then === 'function') src = await src;
    const el = voiceAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedVoiceSrcRef.current = src;
    voiceEndActionRef.current = onEndedAction;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; await el.play(); } catch {}
    } else {
      setVoiceSrc(src);
      setVoiceShouldPlay(true);
    }
  };

  // Helper to programmatically play music audio
  const playMusicAudio = async (src, onEndedAction = null, onPlayAction = null, restartIfSame = true) => {
    if (src && typeof src.then === 'function') src = await src;
    const el = musicAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedMusicSrcRef.current = src;
    musicEndActionRef.current = onEndedAction;
    musicOnPlayActionRef.current = onPlayAction;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; await el.play(); } catch {}
    } else {
      setMusicSrc(src);
      setMusicShouldPlay(true);
    }
  };

  // Helper to programmatically play SFX
  const playSfxAudio = async (src, restartIfSame = true) => {
    const el = sfxAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedSfxSrcRef.current = src;
    if (el && same) {
      if (!restartIfSame) return;
      try { el.pause(); el.currentTime = 0; await el.play(); } catch {}
    } else {
      setSfxSrc(src);
      setSfxShouldPlay(true);
    }
  };

  const timing = [
    {
      timestamp: 0,
    },
    {
      timestamp: 3.9,
    },
    {
      timestamp: 6.2,
    },
    {
      timestamp: 7.8,
    },
    {
      timestamp: 9.4,
    },
    {
      timestamp: 10.31,
    },
    {
      timestamp: 12.61,
    },
    {
      timestamp: 14.21,
    },
    {
      timestamp: 15.81,
    },
    {
      timestamp: 16.7,
    },
    {
      timestamp: 19.02,
    },
    {
      timestamp: 20.62,
    },
    {
      timestamp: 22.22,
    },
    {
      timestamp: 23.09,
    },
    {
      timestamp: 25.43,
    },
    {
      timestamp: 27.03,
    },
    {
      timestamp: 28.63,
    },
    {
      timestamp: 29.54,
    },
    {
      timestamp: 31.84,
    },
    {
      timestamp: 33.44,
    },
    {
      timestamp: 35.04,
    },
    {
      timestamp: 35.95,
    },
    {
      timestamp: 38.25,
    },
    {
      timestamp: 39.85,
    },
    {
      timestamp: 41.45,
    },
    {
      timestamp: 42.36,
    },
    {
      timestamp: 44.66,
    },
    {
      timestamp: 46.26,
    },
    {
      timestamp: 47.86,
    },
    {
      timestamp: 48.77,
    },
    {
      timestamp: 51.07,
    },
    {
      timestamp: 52.67,
    },
    {
      timestamp: 54.27,
    },
    {
      timestamp: 55.18,
    },
    {
      timestamp: 57.48,
    },
    {
      timestamp: 59.08,
    },
    {
      timestamp: 60.68,
    },
    {
      timestamp: 61.59,
    },
    {
      timestamp: 63.89,
    },
    {
      timestamp: 65.49,
    },
    {
      timestamp: 67.09,
    },
  ];

  const [context, setContext] = useState({
    circleCount: 1,
    timingCount: 0,
    activateClickDiv: false,
    clickedOnce: false,
    showCircle1: false,
    showCircle2: false,
    showCircle3: false,
    showCircle4: false,
    timerId: 0,
    secondTimerId: 0,
    startedTutorial: false,
    finishedTutorial: false,
    startedTutorial2: false,
    finishedTutorial2: false,
  });

  // Play tutorial (music channel) when startedTutorial is set
  useEffect(() => {
    if (!context.startedTutorial) return;
    playMusicAudio(
      tutorial,
      () => {
        document.getElementsByClassName('circleDiv')[0].style.display = 'none';
        context.secondTimerId = setTimeout(() => {
          context.activateClickDiv = true;
          context.clickedOnce = false;
          setContext({ ...context });
        }, 1000);
        if (props.unit4) {
          if (tutorial !== props.tutorial1_2) {
            document.getElementById('rightHand').style.display = 'block';
          } else {
            document.getElementById('leftHand').style.display = 'block';
          }
        }
        document.getElementsByClassName('circleDiv')[0].style.display = 'block';
        context.startedTutorial = false;
        setContext({ ...context });
      }
    );
  }, [context.startedTutorial, tutorial]);

  // Play tutorial2 (music channel) when startedTutorial2 is set
  useEffect(() => {
    if (!context.startedTutorial2) return;
    playMusicAudio(
      props.tutorial2,
      () => {
        setPlaySong(true);
      }
    );
  }, [context.startedTutorial2, props.tutorial2]);

  // Play main song (music channel) when playSong is toggled
  useEffect(() => {
    if (!playSong) return;
    playMusicAudio(
      song,
      () => {
        setPlaySong(false);
        setCounting(false);
        if (context.finishedTutorial) {
          if (props.unit3 || props.unit4) {
            document.getElementById('swayingDog').style.display = 'none';
            document.getElementsByClassName('animateDogFollow')[0].style.display = 'block'
            document.getElementsByClassName('circleDiv')[0].style.display = 'none';
            document.getElementById('rightHand').style.display = 'none';
            document.getElementById('leftHand').style.display = 'none';
          }
          setAnimalVoice(awesomeJobAudio);
          setDogState(props.awesomeJob);
          setShowAnimal(true);
          setPlayAwesomeJob(true);
        } else {
          togglePopup();
          document.getElementsByClassName('circleDiv')[0].style.display = 'none';
          document.getElementsByClassName('circleDiv')[1].style.display = 'none';
          document.getElementsByClassName('circleDiv')[2].style.display = 'none';
          document.getElementsByClassName('circleDiv')[3].style.display = 'none';
        }
      },
      () => {
        context.finishedTutorial ? StartFrogs() : props.unit4 ? StartTutorial2() : FloatFrogsTutorial();
      }
    );
  }, [playSong, song]);

  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: props.score,
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 10 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  async function StartFrogs() {
    let count = 0;
    let round = 1;
    if(props.unit3 || props.unit4){
      document.getElementById('swayingDog').style.display='block'
      document.getElementsByClassName('animateDogFollow')[0].style.display='none'
    }
    for (let i = 1; i < timing.length; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      setCounting(false);
      setCountingGif(null)
      await sleep(1);
      if (count === 0) {
        document.getElementsByClassName('circleDiv')[3].style.display = 'none';
        context.activateClickDiv = false;
        setContext({ ...context });
      } else {
        if (count === 1) {
          if(props.unit4){
            document.getElementById('rightHand').style.display =
            'none';
            document.getElementById('leftHand').style.display =
            'none';
          }
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv')[count - 1].style.display =
          'none';
      }
      document.getElementsByClassName('circleDiv')[count].style.display =
        'block';
      if (count === 0) {
        if((round % 2) !== 0 && props.unit4){
          document.getElementById('rightHand').style.display =
          'block';
        }
        else if ((round % 2) === 0 && props.unit4){
          document.getElementById('leftHand').style.display =
          'block';
        }
        setTimeout(() => {
          if(!props.unit3 && !props.unit4) {
            setCounting(true);
            setCountingGif(props.count)
          }
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 600);
      } else {
        if(props.unit3 || props.unit4){
          setTimeout(() => {
            lottieRef.current.anim.goToAndPlay(0, true);
            playSfxAudio(clappingAudio)
          }, 400);
        }
      }
      if(!props.unit3  && !props.unit4){
        setCountingGif(props.count)
        setCounting(true);
      }
      count += 1;
      if (count === 4) {
        round += 1;
        count = 0;
      }
    }
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleDiv')[0].style.display = 'none';
  }

  function increaseCoins() {
    props.module.coins++;
  }

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
  };

  async function FloatFrogsTutorial() {
    let count = 0;
    if(props.unit3 || props.unit4){
      document.getElementById('swayingDog').style.display='block'
      document.getElementsByClassName('animateDogFollow')[0].style.display='none'
    }
    for (let i = 1; i < 9; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp) * 1000
        )
      );
      setCounting(false);
      if (count === 0) {
        document.getElementsByClassName('circleDiv')[3].style.display = 'none';
        context.activateClickDiv = false;
        setContext({ ...context });
      } else {
        if (count === 1) {
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv')[count - 1].style.display =
          'none';
      }
      document.getElementsByClassName('circleDiv')[count].style.display =
        'block';
      if (count === 0) {
        setTimeout(() => {
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 600);
      } else {
        if(props.unit3 || props.unit4){
          lottieRef.current.anim.goToAndPlay(0, true);
          playSfxAudio(clappingAudio)
        }
      }
      count += 1;
      if (count === 4) {
        count = 0;
      }
    }
  }

  async function StartTutorial2() {
    let count = 0;
    for (let i = 1; i < 9; i++) {
      await new Promise((resolve) =>
        setTimeout(
          resolve,
          (timing[i].timestamp - timing[i - 1].timestamp - 0.02) * 1000
        )
      );
      if (count === 0) {
        document.getElementsByClassName('circleDiv')[3].style.display = 'none';
        context.activateClickDiv = false;
        setContext({ ...context });
      } else {
        if (count === 1) {
          document.getElementById('rightHand').style.display =
          'none';
          document.getElementById('leftHand').style.display =
          'none';
          context.activateClickDiv = false;
          setContext({ ...context });
        }
        document.getElementsByClassName('circleDiv')[count - 1].style.display =
          'none';
      }
      document.getElementsByClassName('circleDiv')[count].style.display =
        'block';
      if (count === 0) {
        if(i === 1){
          document.getElementById('rightHand').style.display =
          'block';
        }
        else{
          document.getElementById('leftHand').style.display =
          'block';
        }
        setTimeout(() => {
          context.activateClickDiv = true;
          setContext({ ...context });
        }, 800);
      }
      else{
        setTimeout(() => {
          lottieRef.current.anim.goToAndPlay(0, true);
          playSfxAudio(clappingAudio)
        }, 500);
      }
      count += 1;
      if (count === 4) {
        count = 0;
      }
    }
    document.getElementById('rightHand').style.display =
    'none';
    document.getElementById('leftHand').style.display =
    'none';
  }

  async function leftrightHands(){
    document.getElementById('swayingDog').style.display='block'
    document.getElementsByClassName('animateDogFollow')[0].style.display='none'
    if(tutorial !== props.tutorial1_2){
      document.getElementById('rightHand').style.display =
      'none';
    }
    else{
      document.getElementById('leftHand').style.display =
      'none';
    }
    document.getElementsByClassName('circleDiv')[1].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
      playSfxAudio(clappingAudio)
    }, 500);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleDiv')[1].style.display =
    'none';
    document.getElementsByClassName('circleDiv')[2].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
      playSfxAudio(clappingAudio)
    }, 500);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleDiv')[2].style.display =
    'none';
    document.getElementsByClassName('circleDiv')[3].style.display =
    'block';
    setTimeout(() => {
      lottieRef.current.anim.goToAndPlay(0, true);
      playSfxAudio(clappingAudio)
    }, 500);
    await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
    document.getElementsByClassName('circleDiv')[3].style.display =
    'none';
    if(tutorial !== props.tutorial1_2){
      setTutorial(props.tutorial1_2)
      context.startedTutorial = true;
      setContext({ ...context });
    }
    else{
      context.startedTutorial2 = true;
      setContext({ ...context });
    }
  }

  // Initially starts FTB with or without the tutorial based on what day we're at
  function controllerStart() {
    if (props.module.unlockedDays.day2 || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      setPlayInstructions(true);
      setAnimalVoice(props.instruction);
      setDogState(props.instructionGIF);
      setShowAnimal(true);
      context.finishedTutorial = true;
      setContext({ ...context });
    } else {
      setSong(props.walkthrough);
      context.startedTutorial = true;
      setContext({ ...context });
    }
  }

  // A function that should be removed when the app is deployed, this allows us
  // as devs to skip the entirity of FTB.
  function SkipBubbles() {
    setPlaySong(false);
    if (!props.module.reviewIcon) {
      dispatch({ type: props.stepComplete, payload: 'followthebeat' });
    }
    props.setDisplayFTB(false);
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  return (
    <>
      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
            if (playInstructions) {
              setPlayInstructions(false);
              setPlaySong(true);
            }
            if (playAwesomeJob) {
              updateScore();
              if (!props.module.reviewIcon) {
                dispatch({
                  type: props.stepComplete,
                  payload: 'followthebeat',
                });
              }
              props.module.sectionCompleted = props.module.sectionCompleted + 1
              props.setDisplayFTB(false);
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}

      <div
        id='FollowTheBeatBody7'
        style={{
          backgroundImage: `url(${
            generateImageUrl('images/Module7Images/FTB+Module+7-1.png')
          })`,
        }}
      >
        {(!window.location.href.includes('wearefriends.cool') ? true : window.location.href.includes('staging') ? true : false ) && <button type='button' onClick={SkipBubbles}>
          Skip The Bubbles
        </button>}
        {isOpen && (
          <PopUp
            content={
              <>
                <b id='title'>
                  Ready to begin playing?
                  <br />
                </b>
                <button
                  id='logoutButton1'
                  className='logoutButton'
                  onClick={() => {
                    setCounting(false);
                    togglePopup();
                    setSong(props.song)
                    setPlaySong(true);
                    context.finishedTutorial = true;
                    setContext({ ...context });
                  }}
                >
                  START
                </button>
              </>
            }
            handleClose={togglePopup}
          />
        )}

        <div className='scoreBar'>
          <img className='scoreKey' src={coinBar} alt='dog Icon' />
          {props.module.coins < 10 && (
            <h5 className='scoretext1'>{props.module.coins}</h5>
          )}
          {props.module.coins >= 10 && props.module.coins < 100 && (
            <h5 className='scoretext10'>{props.module.coins}</h5>
          )}
          {props.module.coins >= 100 && (
            <h5 className='scoretext100'>{props.module.coins}</h5>
          )}
          <p className='scoretext'>100</p>
        </div>

        {showCoin && (
          <img
            id={coinAnimationState}
            className='chooseReward'
            src={coin}
            alt='reward key'
            style={{
              position: 'absolute',
              top: '40vh',
              left: '50vw',
              width: '100px',
              height: '100px',
              marginLeft: '-50px',
              marginTop: '-50px',
            }}
            onClick={() => {
              coinAnimation();
            }}
          ></img>
        )}

        <img
          className='back-btn-ftb'
          alt='back button'
          src={Exit}
          onClick={() => {
            props.setDisplayFTB(false);
          }}
        ></img>

        <div className='lottieAnimal' id='swayingDog' style={{display: 'none'}}>
          <LottieAnimation
            ref={lottieRef}
            jsonUrl="appfiles/understand_feelings/swaying_dog.json"
            onAnimationComplete={() => console.log('completed')}
            speed={0.5}
            login={login}

          />
        </div>

        <img className='animateDogFollow' src={dog} alt='dog Icon' />
        {showAnimal && !audioReady && <img id='loading' src={loading} />}
        {showAnimal && (
          <img
            className='animateDogFollow'
            style={audioReady ? {} : { display: 'none' }}
            src={dogState}
            onLoad={() => {
              setDisplayVoice(true);
            }}
            onError={() => setShowAnimal(false)}
          />
        )}
        {!isOpen && (
          <img
            className='animateDogCounting'
            alt="animation"
            src={CountingGif}
            style={counting ? { display: 'block' } : { display: 'none' }}
          />
        )}

        <div id='clickCircleFrog' />
        <img src={left} id='leftHand' alt='left hand'/>
        <img src={right} id='rightHand' alt='right hand'/>
        {context.activateClickDiv ? (
          <div
            id='timedCircleFrog'
            onClick={function () {
              playSfxAudio(poppingAudio);
              if (context.finishedTutorial) {setScore(score + 1)}
              if (context.finishedTutorial || context.startedTutorial2) {
                setCoinAnimationState('coinAnimation');
                setShowCoin(true);
                sleep(1000).then(() => {
                  setShowCoin(false);
                  increaseCoins();
                  setCoinAnimationState('');
                });
              } else {
                context.activateClickDiv = false;
                if (props.unit4){
                  leftrightHands();
                }
                else{
                  context.startedTutorial2 = true;
                }
                document.getElementsByClassName('circleDiv')[0].style.display =
                  'none';
                setContext({ ...context });
              }
              context.activateClickDiv = false;
              setContext({ ...context });
            }}
          ></div>
        ) : (
          <></>
        )}
        <div
          id='circleFrog1'
          className='circleDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module7Images/Unit2_Mod3_FTB_GoldFrog%403x.png')
            })`,
          }}
        ></div>
        <div
          id='circleFrog2'
          className='circleDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module7Images/Unit2_Mod3_FTB_GreenFrog2%403x.png')
            })`,
          }}
        ></div>
        <div
          id='circleFrog3'
          className='circleDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module7Images/Unit2_Mod3_FTB_GreenFrog3%403x.png')
            })`,
          }}
        ></div>
        <div
          id='circleFrog4'
          className='circleDiv'
          style={{
            backgroundImage: `url(${
              generateImageUrl('images/Module7Images/Unit2_Mod3_FTB_GreenFrog4%403x.png')
            })`,
          }}
        ></div>
      </div>
      {/* Always-mounted voice and music audio elements */}
      <audio
        ref={voiceAudioRef}
        src={voiceSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = voiceAudioRef.current;
          if (!el) return;
          const expected = expectedVoiceSrcRef.current;
          const currentSrc = el.currentSrc || el.src;
          if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
          if (!voiceShouldPlay) return;
          el.currentTime = 0;
          el.play().catch(() => {});
        }}
        onEnded={() => {
          const action = voiceEndActionRef.current;
          voiceEndActionRef.current = null;
          setVoiceShouldPlay(false);
          if (typeof action === 'function') action();
        }}
      />
      <audio
        ref={musicAudioRef}
        src={musicSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = musicAudioRef.current;
          if (!el) return;
          if (!musicShouldPlay) return;
          el.currentTime = 0;
          el.play().then(() => {
            const onPlayAction = musicOnPlayActionRef.current;
            if (typeof onPlayAction === 'function') onPlayAction();
          }).catch(() => {});
        }}
        onEnded={() => {
          const action = musicEndActionRef.current;
          musicEndActionRef.current = null;
          setMusicShouldPlay(false);
          if (typeof action === 'function') action();
        }}
      />
      {/* Always-mounted SFX audio element */}
      <audio
        ref={sfxAudioRef}
        src={sfxSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = sfxAudioRef.current;
          if (!el) return;
          const expected = expectedSfxSrcRef.current;
          const currentSrc = el.currentSrc || el.src;
          if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
          if (!sfxShouldPlay) return;
          el.currentTime = 0;
          el.play().catch(() => {});
        }}
        onEnded={() => {
          setSfxShouldPlay(false);
        }}
      />
    </>
  );
};
export default FollowTheBeatModule7;
